<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import ExtendedCheckBoxField from '../forms/ExtendedCheckBoxField.svelte';
  import { getFormContext } from '../forms/FormProviderCore.svelte';

  const { values, setFieldValue } = getFormContext();

  $: allRoles = $values.allRoles;
  $: usedRoles = $values.usedRoles;
</script>

{#each allRoles as role}
  <ExtendedCheckBoxField
    value={usedRoles.includes(role.id)}
    onChange={value => {
      if (value) {
        setFieldValue('usedRoles', [...usedRoles, role.id]);
      } else {
        setFieldValue(
          'usedRoles',
          usedRoles.filter(r => r !== role.id)
        );
      }
    }}
    label={role.name}
  />
{/each}
